import { render, staticRenderFns } from "./publicHeader.vue?vue&type=template&id=86bb0a2c&scoped=true"
import script from "./publicHeader.vue?vue&type=script&lang=js"
export * from "./publicHeader.vue?vue&type=script&lang=js"
import style0 from "./publicHeader.vue?vue&type=style&index=0&id=86bb0a2c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bb0a2c",
  null
  
)

export default component.exports